import React, { useContext } from 'react';
import Context from '../../Context';
import videoStore from '../../videos-store';
import RaisedButton from './RaisedButton';

const styles = {
  height: '2rem',
  maxWidth: '5.5rem',
  fontSize: 'inherit',
  margin: '0.25rem',
};

const getAllTaggedIds = (category) => {
  const taggedVideos = videoStore.filter(video => video.categories.includes(category));
  const taggedIds = taggedVideos.map(video => video.videoId);
  return taggedIds;
};

export default function TagComponent(props) {
  const { category } = props;
  const { setClips } = useContext(Context);

  const taggedIds = getAllTaggedIds(category);

  return (
    <RaisedButton
      className={`tag-${category}`}
      onClick={() => setClips(taggedIds)}
      hover="yellow"
      background="red"
      style={styles}
    >
      {category}
    </RaisedButton>
  );
}
